import React from 'react';
import './LegalPages.css';

const Terms: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          <h1>Terms of Service</h1>
          <p className="legal-date">Last Updated: December 23, 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>📜 Agreement to Terms</h2>
            <p>
              By accessing or using TextCompare.in ("Service"), you agree to be bound by these 
              Terms of Service ("Terms"). If you disagree with any part of these terms, you may 
              not access the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>✅ Use License</h2>
            <p>
              TextCompare.in grants you a personal, non-exclusive, non-transferable, limited 
              license to use the Service for:
            </p>
            <ul>
              <li>Personal text comparison needs</li>
              <li>Professional document review</li>
              <li>Code comparison and review</li>
              <li>Educational purposes</li>
              <li>Commercial use (within reasonable limits)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>🚫 Prohibited Uses</h2>
            <p>You agree NOT to:</p>
            <ul>
              <li>Use the Service for any illegal purpose</li>
              <li>Attempt to hack, reverse engineer, or exploit the Service</li>
              <li>Overload the Service with automated requests (scraping, bots)</li>
              <li>Compare or process content that violates laws or third-party rights</li>
              <li>Resell or redistribute the Service as your own</li>
              <li>Use the Service to process malicious code or malware</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>🎯 Service Availability</h2>
            <p>
              We strive to provide continuous service, but we do not guarantee:
            </p>
            <ul>
              <li>Uninterrupted access (maintenance, updates may occur)</li>
              <li>Error-free operation</li>
              <li>Permanent availability of the Service</li>
            </ul>
            <div className="warning-box">
              <strong>⚠️ Important:</strong> The Service is provided "AS IS" without warranties. 
              Always verify critical comparisons manually.
            </div>
          </section>

          <section className="legal-section">
            <h2>📝 User Content</h2>
            <p>
              Since TextCompare.in operates entirely client-side:
            </p>
            <ul>
              <li>You retain full ownership of any text you compare</li>
              <li>We do not claim any rights to your content</li>
              <li>Your content is never stored on our servers</li>
              <li>You are responsible for ensuring you have rights to compare the content</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>⚖️ Disclaimer of Warranties</h2>
            <p>
              TextCompare.in is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, 
              either express or implied, including but not limited to:
            </p>
            <ul>
              <li>Accuracy of comparison results</li>
              <li>Fitness for a particular purpose</li>
              <li>Non-infringement</li>
              <li>Merchantability</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>🛡️ Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, TextCompare.in and its operators shall not 
              be liable for:
            </p>
            <ul>
              <li>Any indirect, incidental, special, or consequential damages</li>
              <li>Loss of profits, data, or business opportunities</li>
              <li>Damages resulting from use or inability to use the Service</li>
              <li>Errors or inaccuracies in comparison results</li>
            </ul>
            <p className="highlight">
              <strong>Maximum Liability:</strong> In no event shall our total liability exceed $0 (zero dollars), 
              as this is a free service.
            </p>
          </section>

          <section className="legal-section">
            <h2>🔗 Third-Party Links</h2>
            <p>
              Our Service may contain links to third-party websites. We are not responsible for 
              the content, privacy policies, or practices of any third-party sites.
            </p>
          </section>

          <section className="legal-section">
            <h2>📱 Open Source</h2>
            <p>
              TextCompare.in uses open-source libraries (React, TypeScript, diff.js). These are 
              governed by their respective licenses:
            </p>
            <ul>
              <li>React: MIT License</li>
              <li>TypeScript: Apache 2.0 License</li>
              <li>diff.js: BSD License</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>🌐 Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India, 
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>✏️ Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective 
              immediately upon posting. Your continued use of the Service constitutes acceptance 
              of the modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>📧 Contact Information</h2>
            <p>
              For questions about these Terms, please contact:
            </p>
            <ul>
              <li>Email: psachin375@gmail.com</li>
              <li>Website: <a href="/">textcompare.in</a></li>
            </ul>
          </section>

          <div className="legal-footer-note">
            <p>
              <strong>Summary:</strong> Use TextCompare.in responsibly and legally. We provide the 
              tool for free with no guarantees. Your content stays private and local to your device.
            </p>
          </div>
        </div>

        <div className="legal-actions">
          <a href="/" className="btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Terms;